export default __webpack_public_path__ + "static/media/data.9ef46c59.png";